// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FKNJ9","question":"styles_question__1tkzf","inputVisibleButton":"styles_inputVisibleButton__3YOPs","note":"styles_note__2h6VV"};